import { Dropzone } from "dropzone";
import { DirectUpload } from '@rails/activestorage';

export default class DropzoneWithDirectUpload extends Dropzone {
  submitRequest(xhr, formData, files) {
    files.forEach((file, i) => {
      const controller = new DirectUploadController(file, this.directUploadURL, this);

      controller.start((error, blob) => {
        if (error) {
          this._handleUploadError(files, xhr, error);
        } else {
          formData.set(this._getParamName(i), blob.signed_id);
          super.submitRequest(xhr, formData, files);
        }
      });
    });
  }

  directUploadDidProgress(file, xhr, event) {
    this._updateFilesUploadProgress([file], xhr, event);
  }

  get directUploadURL() {
    return this.options.directUploadURL || "/rails/active_storage/direct_uploads"
  }
}

class DirectUploadController {
  constructor(file, url, dropzone) {
    this.file = file
    this.url = url;
    this.dropzone = dropzone;
    this.directUpload = new DirectUpload(this.file, this.url, this);
  }

  start(callback) {
    this.directUpload.create(callback);
  }

  directUploadWillStoreFileWithXHR(xhr) {
    xhr.upload.addEventListener('progress', event => this.dropzone.directUploadDidProgress(this.file, xhr, event));
  }
}
